"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const index_1 = require("store/index");
const button_1 = require("components/atoms/button");
const typography_1 = require("components/atoms/typography");
const rfid_tag_hauler_styles_1 = __importDefault(require("../rfid-tag-hauler.styles"));
const svg_1 = require("components/atoms/svg");
const constants_1 = require("utils/constants");
const rfid_tag_hauler_action_1 = __importDefault(require("../rfid-tag-hauler.action"));
const wsURL = process.env.WS_NESSLAB || '';
const customCellRender = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { appTheme } = (0, index_1.useAppSelector)(state => state.app);
    const cellRender = (cell, { dataIndex, dataItem, field }) => {
        const itemData = dataItem;
        const [rfidTag, setRFIDTag] = (0, react_1.useState)('');
        const handleWebsocket = () => {
            //when click, create new websocket connection
            //when ws opened, send command START
            //when get message with command type READ, consume data, stop websocket
            console.log('scanning...');
            const ws = new WebSocket(wsURL);
            ws.onmessage = event => {
                const data = JSON.parse(event.data);
                if (data.command === 'READ') {
                    console.log(data);
                    setRFIDTag(data.data.hex_tag);
                }
                ws.send(JSON.stringify({ command: 'STOP' }));
                ws.close();
            };
            ws.onopen = () => {
                console.log('send command start');
                ws.send(JSON.stringify({ command: 'START' }));
            };
        };
        if (field === 'rfid_tag') {
            return ((0, jsx_runtime_1.jsx)("td", Object.assign({ id: `${dataIndex}-${itemData.id}` }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: rfid_tag_hauler_styles_1.default.rfidScanDeleteWrapper }, { children: [!itemData.rfid_tag ? ((0, jsx_runtime_1.jsxs)(button_1.Button, Object.assign({ style: rfid_tag_hauler_styles_1.default.buttonSave(appTheme), onClick: handleWebsocket }, { children: [(0, jsx_runtime_1.jsx)(svg_1.ScanIcon, {}), (0, jsx_runtime_1.jsx)(typography_1.Typography, Object.assign({ style: rfid_tag_hauler_styles_1.default.btnStyle }, { children: "Scan" }))] }))) :
                            (0, jsx_runtime_1.jsxs)(button_1.Button, Object.assign({ style: rfid_tag_hauler_styles_1.default.buttonDelete(appTheme), onClick: () => dispatch(rfid_tag_hauler_action_1.default.onClickMutation({ mutationMode: 'delete', dataItem: itemData })) }, { children: [(0, jsx_runtime_1.jsx)(svg_1.DeleteIcon, { color: appTheme === 'dark' ? constants_1.color.black : constants_1.color.white }), (0, jsx_runtime_1.jsx)(typography_1.Typography, Object.assign({ style: rfid_tag_hauler_styles_1.default.btnStyle }, { children: "Delete" }))] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: rfid_tag_hauler_styles_1.default.rfidTag }, { children: rfidTag }))] })) })));
        }
        return cell;
    };
    return cellRender;
};
exports.default = customCellRender;
